// extracted by mini-css-extract-plugin
export var mobileContacts = "MobileContacts-module--mobileContacts--35fa0";
export var toggleButton = "MobileContacts-module--toggleButton--a97bd";
export var active = "MobileContacts-module--active--f60d3";
export var arrowIcon = "MobileContacts-module--arrowIcon--f2cca";
export var arrow = "MobileContacts-module--arrow--d0ad0";